import { offset } from '@floating-ui/dom';
import { StepOptions } from 'shepherd.js';

export enum TourType {
  Home = 1,
  Results = 2,
  Medications = 3,
  Messages = 4,
  Appointments = 5,
  MedicalRecord = 6,
}

/**
 * A tour step plus the tour version in which it was introduced.
 * Steps with no `addedInVersion` are treated as version 1 (original tour).
 * A returning user only sees steps whose `addedInVersion` is greater than the
 * highest version they have already seen.
 */
export type TourStepDefinition = StepOptions & { addedInVersion?: number };

/** The current version of a tour = the highest `addedInVersion` across its steps. */
export function getCurrentTourVersion(steps: TourStepDefinition[]): number {
  return steps.reduce((max, step) => Math.max(max, step.addedInVersion ?? 1), 1);
}

export const DEFAULT_STEP_OPTIONS: StepOptions = {
  classes: 'tour-item',
  scrollTo: false,
  highlightClass: 'tour-highlight',
  modalOverlayOpeningPadding: 8,
  modalOverlayOpeningRadius: 6,
  canClickTarget: false,
  floatingUIOptions: {
    middleware: [offset(12)], //offset the step 12 pixels away from the target element
  },
};
